/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Meta_PublisherInputs */

const ja_playdata_meta_publisher = /** @type {(inputs: Playdata_Meta_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN`)
};

const en_playdata_meta_publisher = /** @type {(inputs: Playdata_Meta_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN`)
};

/**
* | output |
* | --- |
* | "PLAYBRAIN" |
*
* @param {Playdata_Meta_PublisherInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_meta_publisher = /** @type {((inputs?: Playdata_Meta_PublisherInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Meta_PublisherInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_meta_publisher(inputs)
	return en_playdata_meta_publisher(inputs)
});